import React, { useEffect } from "react";
import { Field } from "react-advanced-form";
import { Col, Form } from "react-bootstrap";
import { useFormContext, useFormState } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { AddressLookup, Input } from "../fields";
import { SignQuickOrder } from "../products";
import CustomAddressForm from "./CustomAddressForm";
import { MlsResults } from "./MlsResults";

const AddressForm = () => {
  const { pathname } = useLocation();
  const isSubmitPage = pathname === "/submit";
  const { watch, setValue } = useFormContext();
  const [zone_sku, customAddress] = watch([
    "address_info.zone_sku",
    "customAddress",
  ]);
  const { errors } = useFormState({ name: "address_info" });
  const address_errors = errors.address_info;
  const address_search = !customAddress;
  const hasErrors = !!Object.keys(address_errors || {}).filter(
    (k) => k !== "full_address"
  ).length;
  useEffect(() => {
    if (hasErrors) {
      setValue("customAddress", true);
    }
  }, [hasErrors, setValue]);

  return (
    <>
      <Field.Group name="address">
        {zone_sku === "out-of-area" && (
          <Form.Row>
            <Col xs={12} className="mb-4">
              <p>
                This address is outside of our service area. Please enter a
                different address.
              </p>
            </Col>
          </Form.Row>
        )}
        <Form.Row>
          <Col md={2} className="mb-4">
            <Input
              type="text"
              name="address_info.unit_number"
              label="Unit Number"
              placeholder="15"
            />
          </Col>
          {address_search && (
            <Col md={10} className="mb-4">
              <AddressLookup
                sku="address_info.full_address"
                required
                internalRequired={isSubmitPage}
              />
            </Col>
          )}
          {!address_search && <CustomAddressForm />}
        </Form.Row>
      </Field.Group>
      {!isSubmitPage && (
        <>
          <MlsResults />
          <SignQuickOrder />
          <Form.Row>
            <Col className="mb-4">
              <Input
                type="number"
                label="Approximate Square Footage"
                name="order_info.sq_ft"
                required="In order to provide accurate estimates and suggest correct products, we need to know the approximate interior square footage."
                internalRequired
              />
            </Col>
          </Form.Row>
        </>
      )}
    </>
  );
};

export default AddressForm;
